import React from "react";
import { WSElement, WSElementProps } from "@wingspanhq/fe-component-library";
import styles from "./styles.module.scss";

export const PreviewPhysicalCard: React.FC<WSElementProps> = ({ ...props }) => (
  <WSElement className={styles.previewCard} {...props}></WSElement>
);
